// eslint-disable-next-line import/prefer-default-export
export function ready(cb) {
  return new Promise((resolve) => {
    const done = () => {
      resolve();
      if (typeof cb === 'function') cb();
    };

    if (document.readyState !== 'loading') {
      done();
    } else {
      document.addEventListener('DOMContentLoaded', done);
    }
  });
}
